import React from 'react';
import {
    Comment,
    Form,
    List,
    Input,
    Icon,
    Popover
} from 'antd';
import { ActionSheet, WingBlank, WhiteSpace, Button, Toast, TextareaItem } from 'antd-mobile';
import moment from 'moment';
import userRequest, {
    userApi
} from 'common/request';
import {
    connect
} from 'react-redux';
import {
    actionCreators
} from 'courseLiveInfoStore';
import Emojify from 'react-emojione';
import './index.css'
import ScrollArea from 'react-scrollbar';
import 'emoji-mart/css/emoji-mart.css'
import { Picker } from 'emoji-mart'
import Script from 'react-load-script'
import WsClient from 'common/wsclient';
import rongCloud from 'common/rongcloud';

const isIPhone = new RegExp('\\biPhone\\b|\\biPod\\b', 'i').test(window.navigator.userAgent);
let wrapProps;
if (isIPhone) {
    wrapProps = {
        onTouchStart: e => e.preventDefault(),
    };
}

// 组件 
class Avatar extends React.Component {
    render() {
        return (
            <span className="user-avatar" 
             style={{ color: '#f56a00', backgroundColor: '#fde3cf' }}>
        {this.props.children}
        </span>

        )
    }
}
const CommentList = ({ comments }) => (
    <List
        dataSource={comments}
        itemLayout="horizontal"
        className='commentList'
        renderItem={
            props=> 
                (props.type=='say'
                  ? 
                  <div className="comment-content">
                    <div className="author">{props.to_client_name + ':'}</div>
                    <div className="content"  dangerouslySetInnerHTML={{__html:props.content.title }}></div>
                  </div>
                 
                    : 
                    (props.type=='login'
                      ? 
                      <div className="addroom"> 
                        <span className="hightColor">{props.to_client_name}</span>进入房间
                      </div>
                      :
                      (props.type=='logout'?<div className="addroom"> 
                            <span className="hightColor">{props.to_client_name}</span>离开房间
                      </div>:null
                      )
                  )
                )
        }
    />
)

const Editor = ({
  onChange, onSubmit, submitting, value,onClick,addEmoji,showActionSheet 
}) => (
  <div className="comment-inner">
    <Form.Item  className="input-wrapper">
      <Input  onChange={onChange} value={value}
              placeholder='来参与话题讨论吧...'
              style={{width:'100%',padding:'0.5rem 1.3rem'}}
       prefix={
        <div></div>
      }
      />
    </Form.Item>
    <Form.Item  >
      <div className="sendBtn"
        onClick={onSubmit}
      >
        发送
      </div>
    </Form.Item>
  </div>
);
class TabComment extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
          ws: null,
          comments: [],
          submitting: false,
          value: '',
          type:'',
          reconnect_chat:false,
          data:'',
          name: 'rage',
          roomid:this.props.roomid,
          attempts: 1,
          switch_more:true,
          clicked: 'none',
          isBottom: true,
          updateOnline: null,
        };
    }
    async componentDidMount() {
		var _this = this
        this.setState({
          comments:[]
        })
        const {roomid}= this.props;
        this.connectToChat(roomid)
		    await _this.setupWebsocket(roomid);
    }
    // 数据更新后从新连接聊天室
    /*componentWillReceiveProps(nextProps) {
      if (nextProps.roomid != this.props.roomid) {
        const WS = this.state.ws
        WS&&WS.ws.close()
        WS.ws = null
        this.setState({comments: []}, () => {
          this.setupWebsocket(nextProps.roomid)
        })
      }
    }*/
    componentWillUnmount() {
		const {roomid}= this.props;
      let { ws, updateOnline } = this.state;
      if (ws) ws.close()
      ws.ws = null
	  
	  try {
		  let RongIMLib = window.RongIMLib || {}
		  let { RongIMClient } = RongIMLib
		  RongIMClient.getInstance().quitChatRoom("" +roomid+"", {
		    onSuccess: function() {
		      console.log('退出聊天室成功');
		    },
		    onError: function(error) {
		      console.log('退出聊天室失败');
		    }
		  });
		  
		  RongIMClient.getInstance().disconnect();
	  } catch (e) {
		 console.log(e) 
		}
	  
	  
	  // quitChatRoom(roomid)

      if (updateOnline) {
        clearInterval(updateOnline)
      }
    }
    addEmoji(e){
        console.log('addEmoji',e.colons)
        this.setState(
        {  
        value: [...this.state.value,e.colons]
        });
    }
    connectToChat = (roomid) => {
      let _this = this
      const {userinfo} = _this.props
      let realName = userinfo.get('user_name')||"hqy_guest_"+Math.random();
      let userid =  userinfo.get('user_id');
      try {
          let ws = new WsClient(window.AppConfig.websocketWS, {
            token: JSON.stringify({
              mid: parseInt(userid),
              // key: realName,
              room_id: 'live://'+roomid,
              platform: "web",
              accepts:[parseInt(roomid)]
            }),
            onmessage: (event, revent) => {
              let msgBody;
                switch (event.op) {
                  case 6:
                    msgBody  = {
                      type:'logout',
                      to_client_id: userid,
                      roomId: roomid,
                      to_client_name: realName,
                      time: moment().format('MM-DD HH:mm:ss')
                    }
                    _this.props.sendMessage(roomid, JSON.stringify(msgBody))
                    break;

                  case 8:
                    msgBody  = {
                      type:'login',
                      to_client_id: userid,
                      roomId: roomid,
                      to_client_name: realName,
                      time: moment().format('MM-DD HH:mm:ss')
                    }
                    _this.setComment(msgBody)
                    this.props.sendMessage(roomid, JSON.stringify(msgBody))
                    break;
                    
                  case 9:
                    // 解析 body
                    try {
                      let nbody = JSON.parse(revent.nbody);
            if (nbody.to_client_id == userid) {
              return
            }
                      if (nbody.type == 'login') {
                        // _this.props.getOnLine()
                        // _this.props.getTestOnLine(_this.props.onLinePeople + 1)
                      } else if (nbody.type == 'logout') {
                        // _this.props.getOnLine()
                        // _this.props.getTestOnLine(_this.props.onLinePeople - 1)
                        return;
                      }
                      _this.setComment(nbody)
                    } catch (e) {}
                    break;
                }
            },
            onclose: () => {
              const msgBody  = {
                type:'logout',
                to_client_id: userid,
                roomId: roomid,
                to_client_name: realName,
                time: moment().format('MM-DD HH:mm:ss')
              }
              _this.props.sendMessage(roomid, JSON.stringify(msgBody))
            },
          })
          this.setState({ws})
      } catch(e) {
        console.log('catch',e);
      }
    }
    async setupWebsocket(roomid){ // 连接websocket
        var _this = this
		let RongIMLib = window.RongIMLib || {}
		let { RongIMClient } = RongIMLib
        const {userinfo} =_this.props
        let realName = userinfo.get('user_name')||"hqy_guest_"+Math.random();
        let userid =  userinfo.get('user_id');
		
		RongIMClient.init(window.AppConfig.RongCloudAppKey)
		RongIMClient.setConnectionStatusListener({
		  onChanged: function (status) {
		    // status 标识当前连接状态
		    switch (status) {
		      case RongIMLib.ConnectionStatus.CONNECTED:
		        console.log('链接成功');
		        break;
		      case RongIMLib.ConnectionStatus.CONNECTING:
		        console.log('正在链接');
		        break;
		      case RongIMLib.ConnectionStatus.DISCONNECTED:
		        console.log('断开连接');
		        break;
		      case RongIMLib.ConnectionStatus.KICKED_OFFLINE_BY_OTHER_CLIENT:
		        console.log('其他设备登录, 本端被踢');
		        break;
		      case RongIMLib.ConnectionStatus.DOMAIN_INCORRECT:
		        console.log('域名不正确, 请至开发者后台查看安全域名配置');
		        break;
		      case RongIMLib.ConnectionStatus.NETWORK_UNAVAILABLE:
		        console.log('网络不可用, 此时可调用 reconnect 进行重连');
		        break;
		      default:
		        console.log('链接状态为', status);
		        break;
		    }
		  }
		});
		
		const chatRoomId = "" + roomid + ""
		
		const token = await new Promise((resolve, reject) => {
				// 测试  随机生成用户  
				// function uuid() {
				// 	var s = [];
				// 	var hexDigits = "0123456789abcdef";
				// 	for (var i = 0; i < 36; i++) {
				// 		s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
				// 	}
				// 	s[14] = "4";  // bits 12-15 of the time_hi_and_version field to 0010
				// 	s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);  // bits 6-7 of the clock_seq_hi_and_reserved to 01
				// 	s[8] = s[13] = s[18] = s[23] = "-";
				  
				// 	var uuid = s.join("");
				// 	return uuid;
				// }
				// userid = uuid()
				rongCloud.getToken(userid, realName, "", (t) => {
					resolve(t)
				})
			})
			
		// const token = 'u+AxIMlqQpmH3NgPiN0GMBSBd/vg75pm7RTXt++cvc4PuiXs9GEC6/TsTWwZV9JXfebd210kk7w='
		
		await new Promise((resolve, reject) => {
				RongIMClient.connect(token, {
				  onSuccess: function(userId) {
					console.log('连接成功, 用户 id 为', userId);
					// 连接已成功, 此时可通过 getConversationList 获取会话列表并展示
					resolve(userId)
				  },
				  onTokenIncorrect: function() {
					console.log('连接失败, 失败原因: token 无效');
				  },
				  onError: function(errorCode) {
					var info = '';
					switch (errorCode) {
					  case RongIMLib.ErrorCode.TIMEOUT:
						info = '链接超时';
						break;
					  case RongIMLib.ConnectionState.UNACCEPTABLE_PAROTOCOL_VERSION:
						info = '不可接受的协议版本';
						break;
					  case RongIMLib.ConnectionState.IDENTIFIER_REJECTED:
						info = 'appkey 不正确';
						break;
					  case RongIMLib.ConnectionState.SERVER_UNAVAILABLE:
						info = '服务器不可用';
						break;
					  default:
						info = errorCode;
						break;
					}
					console.log('连接失败, 失败原因: ', info);
				  }
				});
			});
		
		await new Promise((resolve, reject) => {
				RongIMClient.getInstance().joinChatRoom(chatRoomId, 0, {
				  onSuccess: function() {
					console.log('加入聊天室成功');
					resolve()
				  },
				  onError: function(error) {
					console.log('加入聊天室失败', error);
					reject(error)
				  }
				});
			});
		
		const getChatRoomInfo = () => {
			return new Promise((resolve, reject) => {
				var order = RongIMLib.GetChatRoomType.REVERSE;
				RongIMClient.getInstance().getChatRoomInfo(chatRoomId, 0, order, {
				  onSuccess: function(chatRoom) {
				    /*
				        chatRoom.userInfos  聊天室成员信息
				        chatRoom.userTotalNums  聊天室总人数
				      */
				    console.log('获取聊天室信息成功', chatRoom);
					resolve(chatRoom)
				  },
				  onError: function(error) {
				    console.log('获取聊天室信息失败', error);
					reject(error)
				  }
				});
			});
		}
		
		const { userTotalNums } = await getChatRoomInfo()
		_this.props.getTestOnLine(userTotalNums)
		
		// 每30秒 更新人数
		let updateOnline = setInterval(() => {
		  getChatRoomInfo().then(({ userTotalNums }) => {
			  _this.props.getTestOnLine(userTotalNums)
		  })
		}, 1000 * 5)
		_this.setState({updateOnline})

		// console.log(userTotalNums)	
		

        // await _this.props.getOnLine() 暂时不获取真实在线人数

        // 每30秒 更新人数
        /*let updateOnline = setInterval(() => {
          _this.props.getOnLine()
        }, 1000 * 30)
        _this.setState({updateOnline})*/

        let num = 0;
        
    }

    setComment(nbody) {
      this.setState({comments: [...this.state.comments, nbody]})
      if (this.state.isBottom&&this.contentNode) setTimeout(() => {
        this.contentNode.scrollArea.scrollBottom()
      }, 100)
    }

    sendData(title){
        const {userinfo, roomid} =this.props;
        let date =  moment().format('MM-DD HH:mm:ss');
        let user = userinfo.toJS()
        let realName = user.user_name?user.user_name:''
        let userid = user.user_id?user.user_id:''
        const send_data = {
              type:'say',
              to_client_id: userid,
              roomId: roomid,
              to_client_name: realName,
              content:{
                title
              },
              time: date
        }
        this.setComment(send_data)
        this.props.sendMessage(roomid, JSON.stringify(send_data))
    }
    handleSubmit = () => {
        if (!this.state.value) return
        this.sendData(this.state.value)
        this.setState({value: ''})
        console.log('handleSubmit',this.state.value)
    }
    handleChange = (e) => {
        this.setState({
          value: e.target.value,
        });
    }
    changeMemberList (list){
        const {getMemberList} =this.props;
        getMemberList(list)
    }
    clickMore(){
        const {getChat,roomid,chatList} =this.props
        this.setState({
          switch_more : false
        })
        getChat(roomid) 
        setTimeout(()=>{
         if(this.contentNode&&this.contentNode.scrollArea){
            this.contentNode.scrollArea.scrollBottom() 
          }
        },0) 
    }
 
    showActionSheet = () => {
        const BUTTONS = ['# 你最喜欢的电影是什么 #', '# 你最喜欢的喜欢的电影... #', '# 你最喜欢的喜欢的电影... #', 'Cancel'];
        ActionSheet.showActionSheetWithOptions({
          options: BUTTONS,
          cancelButtonIndex: BUTTONS.length - 1,
          message: '选择话题',
          maskClosable: true,
          'data-seed': 'logId',
          wrapProps,
        },
        (buttonIndex) => {
          if(BUTTONS[buttonIndex]==='Cancel'){
            this.setState({ 
              clicked: '',
               value: '',
              });
          }else{
            this.setState({ 
               clicked: BUTTONS[buttonIndex] ,
               value: '<span class="ht">'+BUTTONS[buttonIndex]+'</span>',
            });
          }
          
        });
    }
  render() {
	 let _this = this;
    const { comments, submitting, value } = this.state;
 
    return (
      <div className="des-main des-main-comment" >
        <ScrollArea
            className='commentScroll'
            contentClassName='commentContent'
            smoothScrolling = {true}
            ref={ node => this.contentNode = node }>
            <div
                className="des-main-inner"
                onTouchStart={() => {this.setState({isBottom: false})}}
                onTouchEnd={() => {this.setState({isBottom: true})}}>
                {/*<div className={ this.state.switch_more ? 'des-more' : 'des-more-none' }onClick={()=>{this.clickMore()}}>
                  <Icon type="clock-circle" />
                  <span>查看更多</span> 
                </div>*/}
                <WingBlank>
                  {
                    comments.length > 0 && <CommentList comments={comments} />
                  }
                </WingBlank>
            </div>
        </ScrollArea>
        <Comment
          className="comment-box"
          content={(
            <div>
            <Editor
              onChange={this.handleChange}
              onSubmit={this.handleSubmit}
              submitting={submitting}
              value={value }
              showActionSheet={this.showActionSheet}
              addEmoji={(e)=>{this.addEmoji(e)}}
            /></div>
          )}
        />
      </div>
    );
  }
}


const mapState = (state) => ({ 
  userinfo:state.getIn(['home','userinfo']),
  memberlist:state.getIn(['courseliveinfo','memberlist']),
  chatList:state.getIn(['courseliveinfo','chatList'])
 })
 

const mapDispatch = (dispatch) => ({
  sendMessage(roomid,body){
    dispatch(actionCreators.sendMessage(roomid,body))
  },
  getMemberList(data){
    dispatch(actionCreators.getMemberList(data))
  },
  addMemberList(data){
    dispatch(actionCreators.addMemberList(data))
  },
  removeMemberList(id){
    dispatch(actionCreators.removeMemberList(id))
  },
  addChat(content,user_id,course_id,user_name){
    dispatch(actionCreators.addChat(content,user_id,course_id,user_name))
  },
  getChat(course_id){
    dispatch(actionCreators.getChat(course_id))
  }
})
export default connect(mapState, mapDispatch)(TabComment);